export const QUERY_APPOINTMENT_KEY = 'berrystreetGetAppointmentByRoomId';
export const QUERY_SESSION_NOTE_KEY = 'berrystreetGetSessionNote';
export const QUERY_SESSION_NOTE_WITH_AI_KEY = 'berrystreetGetSessionNoteWithAi';
export const QUERY_SESSION_NOTES_KEY = 'berrystreetGetSessionNotes';
export const QUERY_SUPERVISION_TASKS_KEY = 'berrystreetGetSupervisionTasks';
export const QUERY_NEW_ENROLLMENTS_KEY = 'berrystreetGetNewEnrollments';
export const QUERY_ENROLLMENTS_KEY = 'berrystreetGetEnrollments';
export const QUERY_SLUG_KEY = 'berrystreetGetSlug';
export const QUERY_INSURANCE_DETAILS_KEY = 'berrystreetGetInsuranceDetails';
export const QUERY_MEETING_TOKEN_KEY = 'berrystreetGetMeetingToken';
export const QUERY_DAILY_ROOM_INFO_KEY = 'berrystreetGetDailyRoomInfo';
export const QUERY_MEAL_PLAN_INSTRUCTIONS =
  'berrystreetGetMealPlanInstructions';
export const QUERY_MEAL_PLAN = 'berrystreetGetMealPlan';
export const QUERY_MEAL_PLAN_SUMMARY = 'berrystreetGetMealPlanSummary';
export const QUERY_MEAL_PLAN_PREVIOUS_APPOINTMENT =
  'berrystreetGetMealPlanPreviousAppointment';

export const PATIENT_DETAILS_QUERY_KEY = 'berrystreetGetPatientDetails';
export const UPCOMING_APPOINTMENTS_QUERY_KEY = 'healthieUpcomingAppointments';
export const QUERY_SCHEDULE_FOLLOW_UPS_KEY = 'berrystreetScheduleFollowUps';
export const QUERY_APP_USER_STATUS_KEY = 'appUserStatus';
export const QUERY_INVOICES_KEY = 'berrystreetGetInvoices';
export const QUERY_W9_STATUS_KEY = 'berrystreetGetW9Status';
export const QUERY_GROUP_PRACTICE_PROVIDERS_KEY =
  'berrystreetGetGroupPracticeProviders';
export const QUERY_NOTIFICATIONS_KEY = 'berrystreetGetNotifications';
export const QUERY_BENEFITS_CHECK_KEY = 'berrystreetGetBenefitsCheck';
export const QUERY_ICD_CODES_KEY = 'berrystreetSearchIcdCodes';
export const QUERY_BENEFIT_CHECK_REQUESTS_KEY =
  'berrystreetGetBenefitCheckRequests';
export const QUERY_ANNOUNCEMENTS_KEY = 'berrystreetGetAnnouncements';
export const QUERY_PROVIDER_ELIGIBILITY_KEY =
  'berrystreetGetProviderEligibility';
export const QUERY_NON_APPOINTMENT_HOURS_KEY =
  'berrystreetGetNonAppointmentHours';
export const QUERY_NON_APPOINTMENT_HOURS_SETTINGS_KEY =
  'berrystreetGetNonAppointmentHoursSettings';
export const QUERY_INTRO_VIDEO_STATUS_KEY = 'berrystreetGetIntroVideoStatus';
